import styled, { keyframes } from "styled-components";

const S = {
    carousel: styled.div`
        display: flex;
        overflow: hidden;
        height: 100vh;
        width: 100%;
        position: relative;
    `,
    carouselItem: styled.div`
        position: relative;
        flex: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        overflow: hidden;
        transition: flex 1s ease;
      
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.7) 100%);
            z-index: 1;
        }

        video {
            position: absolute;
            top: 50%;
            left: 50%;
            min-width: 100%;
            min-height: 100%;
            width: auto;
            height: auto;
            transform: translate(-50%, -50%);
            object-fit: cover;
            z-index: 0;
        }

        &.current {
            flex: 1;
        }
    `,
    carouselHeading: styled.div`
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
        max-width: 1200px;
        z-index: 2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding: 0 40px;
        opacity: 1;
        transition: opacity 0.8s ease-in-out;

        &.show {
            opacity: 0;
        }

        @media (max-width: 768px) {
            padding: 0 20px;
            align-items: center;
            text-align: center;
        }

        .left {
            width: 100%;
            max-width: 800px;
            display: flex;
            flex-direction: column;
            
            @media (max-width: 768px) {
                align-items: center;
            }

            h2 {
                color: #ffffff;
                font-size: 4em;
                font-weight: 800;
                line-height: 1.1;
                margin: 0 0 20px 0;
                text-shadow: 0 10px 30px rgba(0,0,0,0.3);
                text-align: left;
                
                @media (max-width: 768px) {
                    font-size: 2.5em;
                    text-align: center;
                }
            }

            .pAuto, p {
                color: rgba(255, 255, 255, 0.9);
                font-size: 1.25em;
                line-height: 1.6;
                margin-bottom: 30px;
                text-align: left;
                text-shadow: 0 2px 10px rgba(0,0,0,0.5);
                font-weight: 400;

                @media (max-width: 768px) {
                    font-size: 1.1em;
                    text-align: center;
                }
            }
        }
    `,
    RandevuWrap: styled.div`
        display: flex;
        flex-direction: row;
        gap: 20px;
        margin-top: 20px;

        @media (max-width: 768px) {
            display: none;
        }

        a {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 16px 32px;
            border-radius: 50px;
            font-size: 1.1em;
            font-weight: 600;
            text-decoration: none;
            transition: all 0.3s ease;
            backdrop-filter: blur(10px);
            
            &:first-child {
                background: #00A9C4;
                color: white;
                box-shadow: 0 10px 30px rgba(0, 169, 196, 0.4);
                
                &:hover {
                    background: white;
                    color: #00A9C4;
                    transform: translateY(-3px);
                    box-shadow: 0 15px 35px rgba(255, 255, 255, 0.3);
                    
                    .tele {
                        filter: brightness(0) saturate(100%) invert(48%) sepia(85%) saturate(2250%) hue-rotate(151deg) brightness(97%) contrast(101%);
                    }
                }
            }
            
            &:last-child {
                background: rgba(255, 255, 255, 0.15);
                color: white;
                border: 1px solid rgba(255, 255, 255, 0.3);
                
                &:hover {
                    background: rgba(255, 255, 255, 0.25);
                    transform: translateY(-3px);
                }
            }

            .tele {
                width: 20px;
                margin-left: 12px;
                transition: all 0.3s ease;
                filter: brightness(1000%);
            }
        }
    `,
    RandevuWrapMobile: styled.div`
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 30px;
        width: 100%;

        @media (min-width: 768px) {
            display: none;
        }

        a {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 16px 32px;
            border-radius: 50px;
            font-size: 1.1em;
            font-weight: 600;
            text-decoration: none;
            transition: all 0.3s ease;
            width: 100%;
            box-sizing: border-box;
            
            &:first-child {
                background: #00A9C4;
                color: white;
                box-shadow: 0 10px 30px rgba(0, 169, 196, 0.4);
            }
            
            &:last-child {
                background: rgba(255, 255, 255, 0.15);
                color: white;
                border: 1px solid rgba(255, 255, 255, 0.3);
                backdrop-filter: blur(10px);
            }

            .tele {
                width: 20px;
                margin-left: 12px;
                filter: brightness(1000%);
            }
        }
    `
};

export default S;